module.exports = __webpack_public_path__ + "static/img/06.9981630a.jpg";